import {
  faHouse,
  faBullseye,
  faEnvelope,
  faArrowAltCircleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import { SubdomainOrgIdObject } from "./FunctionsAndInterfaces";
import { SignOut } from "../pages/sign-out/SignOut";
import { Page } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { GallusAgilityRedirect } from "../pages/demos/gallus-agility/GallusAgilityRedirect";
import { Redirect } from "../Redirect";

const orgId: number = 184485983;
const subDomain: string = "agility";
const nameOfProduct: string = "Agility";
const secureRouteGroups: string[] = ["Agility", "GallusAgility"];

export const agilityObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
};

const sidebarMenu = () => {
  return (
    <>
      <MenuItem>
        <Link to={`/${subDomain}`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faHouse} />
            Home
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/chat`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faBullseye} />
            Chat with Agility
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/contactus`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEnvelope} />
            Contact Us
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`/${subDomain}/signout`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
            Log Out
          </div>
        </Link>
      </MenuItem>
    </>
  );
};

export const agilityRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: <Redirect redirectTo={`/${subDomain}/product`} />,
    },
    {
      path: `/${subDomain}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              enableFullFeatures={true}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={agilityObject}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/chat`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          groups={secureRouteGroups}
          element={<GallusAgilityRedirect />}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
